import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

const defaultTheme = {
  primaryColor: '#d60167',
  secondaryColor: '#000000',
  backgroundColor: '#ffffff',
  textColor: '#1c1d1d',
  borderColor: '#e5e5e5',
  mutedText: '#888888'
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(defaultTheme);

  const applyTheme = (colors) => {
    const finalTheme = { ...defaultTheme, ...colors };

    document.documentElement.style.setProperty('--primary-color', finalTheme.primaryColor);
    document.documentElement.style.setProperty('--secondary-color', finalTheme.secondaryColor);
    document.documentElement.style.setProperty('--bg-color', finalTheme.backgroundColor);
    document.documentElement.style.setProperty('--text-color', finalTheme.textColor);
    document.documentElement.style.setProperty('--border-color', finalTheme.borderColor);
    document.documentElement.style.setProperty('--muted-text', finalTheme.mutedText);
  };

  const fetchTheme = async () => {
    try {
      const res = await api.get('/theme');
      const serverTheme = { ...defaultTheme, ...res };

      setTheme(serverTheme);
      applyTheme(serverTheme);
      localStorage.setItem('themeColors', JSON.stringify(serverTheme));
    } catch (err) {
      const savedTheme = localStorage.getItem('themeColors');

      if (savedTheme) {
        const parsed = JSON.parse(savedTheme);
        setTheme(parsed);
        applyTheme(parsed);
      } else {
        applyTheme(defaultTheme);
      }
    }
  };

  const updateTheme = async (newTheme) => {
    try {
      const res = await api.put('/theme', newTheme);
      const updatedTheme = { ...defaultTheme, ...res };

      setTheme(updatedTheme);
      applyTheme(updatedTheme);
      localStorage.setItem('themeColors', JSON.stringify(updatedTheme));

      return { success: true, theme: updatedTheme };
    } catch (err) {
      return {
        success: false,
        error: err.response?.data?.message || err.message || 'Theme update failed'
      };
    }
  };

  useEffect(() => {
    fetchTheme();
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, updateTheme, fetchTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;